const RELOAD_KEY = 'ollaa:stale-chunk-reload';

export function isStaleChunkLoadError(error) {
  const message = error?.message || String(error || '');
  return /Failed to fetch dynamically imported module/i.test(message)
    || /Importing a module script failed/i.test(message)
    || /error loading dynamically imported module/i.test(message)
    || /Loading chunk [\d]+ failed/i.test(message)
    || /Loading CSS chunk [\d]+ failed/i.test(message);
}

/**
 * After a deploy, an old JS bundle may still be in memory and request deleted chunks.
 * Reload once so index.html + SW can serve the current build.
 */
export function reloadOnceOnStaleChunk(error) {
  if (!isStaleChunkLoadError(error)) {
    return false;
  }

  try {
    if (sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.removeItem(RELOAD_KEY);
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, '1');
  } catch {
    // sessionStorage unavailable — still try one reload
  }

  window.location.reload();
  return true;
}

export function installStaleChunkReloadHandlers() {
  if (import.meta.env.DEV) {
    return;
  }

  window.addEventListener('unhandledrejection', (event) => {
    if (reloadOnceOnStaleChunk(event.reason)) {
      event.preventDefault();
    }
  });
}
